/* Las columnas salen de CUÁNTAS tarjetas hay, no de cuántas caben en el
 * ancho. auto-fit maximiza columnas; acá se busca equilibrio: con 4 queremos
 * 2×2, no cuatro angostas. Nunca más de 4; la fila incompleta va abajo.
 * Lo usan la rejilla de estado del dashboard y las de Relacionados. */
export function balancedColumns(n: number): number {
  if (n <= 3) return n;   // 1, 2, 3 → una sola fila
  if (n === 4) return 2;  // 2 × 2
  if (n <= 6) return 3;   // 3+2 · 3+3
  return 4;               // 4+3 · 4+4
}
